import UserInviteList from './UserInviteList';
import UserInviteShow from './UserInviteShow';

export default {
  list: UserInviteList,
  show: UserInviteShow,
};
